import React, { useState, Fragment } from 'react';
import { useSelector } from 'react-redux';

import {
  Box,
  List,
  Divider,
  ListItem,
  Typography,
  IconButton,
  ListItemText,
  ListItemSecondaryAction,
} from '@material-ui/core';

import { useStyles, listTextStyles, listItemsStyles } from './PricingRulesWidget.styled';

import moment from 'moment';
import i18n from 'i18n-js';
import Can from 'components/Can';
import { Card } from 'components/UI';
import Paginator from 'components/Paginator';
import { withRouter } from 'react-router-dom';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { ChangePricingRulesModal } from 'components/Modals';

const PricingRulesWidget = ({
  pagination = {},
  params,
  onDelete,
  currentGroup,
  handleChangePage,
  fleet,
}) => {
  const classes = useStyles();
  const listClasses = listTextStyles();
  const listItemsClasses = listItemsStyles();
  const [open, setOpen] = useState(false);
  const {
    loading,
    relatedRulesets,
    onboarding: { steps },
  } = useSelector((state) => state.vehiclesGroups);
  const { localeFormat } = useSelector((state) => state.organizations);
  const handleRulesModalOpen = () => {
    setOpen((prevState) => !prevState);
  };

  /**
   * Vertical menu list
   * It has the label and the function for each action
   */
  const items = [
    {
      title: i18n.t('pricing_rules.edit'),
      can: { name: 'vehicle_group', action: 'update' },
      onClick: handleRulesModalOpen,
    },
  ];

  const onDeleteClick = (item) => {
    const ruleSetId = item.id;
    onDelete(ruleSetId);
  };

  const getRulesets = () => {
    return steps?.pricing?.groupRulesets?.length
      ? steps?.pricing?.groupRulesets
      : [steps?.pricing?.currentRuleset];
  };

  return (
    <Card
      menuItems={items}
      headerActionType="vertical"
      data-cy="pricing-widget-card"
      title={i18n.t('pricing_rules.title')}
    >
      <Box className={classes.cardContentPadding}>
        {steps?.pricing?.currentRuleset?.rule_set ? (
          <>
            <List className={classes.list} data-cy="pricing-widget-card-list">
              {getRulesets()?.map((val, index) => (
                <Fragment key={index}>
                  <ListItem>
                    <ListItemText
                      classes={listClasses}
                      primary={
                        // `${val?.rule_set?.name}`
                        <Box
                          display="flex"
                          component="span"
                          flexDirection="column"
                          // className={classes.textRight}
                        >
                          <Typography variant="body2" component="span" color="textSecondary">
                            {val?.rule_set?.name}
                          </Typography>
                          <Box display="flex" component="span" flexDirection="row" flexWrap="wrap">
                            {val?.start_time && (
                              <Typography
                                variant="body2"
                                component="span"
                                color="textSecondary"
                                className={classes.time}
                              >
                                <b>{i18n.t('common.start')}:</b>{' '}
                                {moment(val?.start_time).format(`${localeFormat} h:mm A`)}
                              </Typography>
                            )}
                            {val?.end_time && (
                              <Typography
                                variant="body2"
                                component="span"
                                color="textSecondary"
                                className={classes.time}
                              >
                                <b>{i18n.t('common.end')}:</b>{' '}
                                {moment(val?.end_time).format(`${localeFormat} h:mm A`)}
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      }
                    />
                    <ListItemSecondaryAction classes={listItemsClasses}>
                      <Can I="update" a="vehicle_group">
                        <Box
                          fontSize={13}
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <IconButton onClick={handleRulesModalOpen}>
                            <EditIcon
                              style={{ color: '#8E8E93', fontSize: 16, cursor: 'pointer' }}
                            />
                          </IconButton>
                          {steps?.pricing?.groupRulesets?.length ? (
                            <IconButton onClick={() => onDeleteClick(val)}>
                              <DeleteIcon
                                style={{ color: '#8E8E93', fontSize: 16, cursor: 'pointer' }}
                              />
                            </IconButton>
                          ) : (
                            ''
                          )}
                        </Box>
                      </Can>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider className={classes.divider} />
                </Fragment>
              ))}
            </List>
            <Paginator
              component="div"
              limit={params.limit}
              pagination={pagination}
              rowsPerPageOptions={[3]}
              onPageChange={handleChangePage}
            />
          </>
        ) : (
          <Typography color="textPrimary" style={{ lineHeight: 1 }}>
            <Box fontSize={14} component="span" lineHeight={1}>
              {i18n.t('pricing_rules.no_pricing_rules')}
            </Box>
          </Typography>
        )}
      </Box>
      {open && (
        <ChangePricingRulesModal
          open={open}
          steps={steps}
          loading={loading}
          vehicleGroup={currentGroup}
          relatedRulesets={relatedRulesets}
          handleClick={handleRulesModalOpen}
          fleet={fleet}
        />
      )}
    </Card>
  );
};

export default withRouter(PricingRulesWidget);
